import {
  AccountAddProvider,
  AccountOperProvider,
  AccountSearchProvider,
  AccountService,
  AccountViewProvider,
  HttpService,
} from '@lk/api'

export const makeAccountService = (http: HttpService, baseUrl: string) =>
  new AccountService(
    new AccountSearchProvider(http, baseUrl),
    new AccountViewProvider(http, baseUrl),
    new AccountAddProvider(http, baseUrl),
    new AccountOperProvider(http, baseUrl),
  )
